import React from "react";

/**
 * The masthead every interior page opens with. One component so /team, /blogs,
 * /info, /donate and the legal pages share an identical measure and rhythm
 * instead of each inventing its own heading sizes and top padding.
 *
 * Variants:
 *   paper — default, warm ground with a hairline base
 *   dark  — deep forest ground, used where the page continues into imagery
 */
export default function PageHeader({
  kicker,
  title,
  lede,
  meta,
  aside,
  variant = "paper",
}) {
  const dark = variant === "dark";

  return (
    <header
      className={
        dark
          ? "bg-agri-forest text-white"
          : "border-b border-agri-rule bg-agri-card"
      }
    >
      <div className="container-x page-top pb-14 sm:pb-16 lg:pb-20">
        {kicker && (
          <p className={dark ? "kicker-light" : "kicker-rule"}>{kicker}</p>
        )}

        <div className="mt-6 grid grid-cols-1 gap-x-12 gap-y-6 lg:grid-cols-12 lg:items-end">
          <div className={aside || lede ? "lg:col-span-7" : "lg:col-span-9"}>
            <h1
              className={`text-balance font-display text-h1 font-semibold leading-[1.02] tracking-[-0.03em] sm:text-h1Lg ${
                dark ? "text-white" : "text-agri-ink"
              }`}
            >
              {title}
            </h1>
            {meta && (
              <p
                className={`mt-5 font-mono text-[0.6875rem] uppercase tracking-[0.12em] ${
                  dark ? "text-white/65" : "text-agri-ink40"
                }`}
              >
                {meta}
              </p>
            )}
          </div>

          {(lede || aside) && (
            <div className="lg:col-span-5">
              {lede && (
                <p
                  className={`max-w-measure text-lede ${
                    dark ? "text-white/70" : "text-agri-ink80"
                  }`}
                >
                  {lede}
                </p>
              )}
              {aside && <div className="mt-6">{aside}</div>}
            </div>
          )}
        </div>
      </div>
    </header>
  );
}
